import { render, staticRenderFns } from "./SolicitudApertura.vue?vue&type=template&id=57c2068e&scoped=true&"
import script from "./SolicitudApertura.vue?vue&type=script&lang=js&"
export * from "./SolicitudApertura.vue?vue&type=script&lang=js&"
import style0 from "./SolicitudApertura.vue?vue&type=style&index=0&id=57c2068e&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "57c2068e",
  null
  
)

export default component.exports